
(function containerTypeControllerDefinition() {
    'use strict';

    angular.module('ContainerType')
        .controller('ContainerTypeAddController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', '$stateParams', 'adminContainerTypeService', 'authExtend', 'functionService',
            function containerTypeController($scope, config, $state, $translate, errors, $stateParams, adminContainerTypeService, authExtend, functionService) {
                // si no tiene el permisos solo puede crear de edr
                $scope.allApps = authExtend.isInRole('CONFIG ADMIN APPS');

                $scope.title = 'ContainerTypeAdd';

                if ($scope.allApps) {
                    functionService.getApps().then(function getOk(result) {
                        $scope.optionApps = result;
                    }, function getError(error) {
                        errors.showError(error);
                    });
                }

                $scope.document =
                    {
                        name: '',
                        systemName: '',
                        organizationalUnitId: authExtend.getOrganizationId(),
                        organizationalUnitName: authExtend.getOrganizationName(),
                        virtual: 'Virtual',
                        app: []
                    };

                $scope.requiredOu = authExtend.getOrganizationId() ? true : false;

                $scope.selectApp = function (item) {
                    if (!Array.isArray($scope.tempApp)) {
                        $scope.tempApp = [];
                    }

                    $scope.tempApp.push(item)
                };

                $scope.removeApp = function (item) {
                    var index = $scope.tempApp.indexOf(item);
                    if (index > -1) {
                        $scope.tempApp.splice(index, 1);
                    }
                };

                $scope.save = function () {
                    if (!$scope.containerTypeForm.$valid) {
                        $scope.containerTypeForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if ($scope.tempApp) {
                        $scope.document.Applications = [];
                        $scope.tempApp.forEach(function (item) {
                            $scope.document.Applications.push({ ApplicationId: item.id });
                        });
                    }

                    $scope.document.maxDocumentVersion = $scope.document.maxDocumentVersion == 0 ? null : $scope.document.maxDocumentVersion;

                    return adminContainerTypeService.create($scope.document).then(function () {
                        if (document && document.id) {
                            $state.go('container-type-metadata', { id: document.id });
                        }
                        else {
                            $state.go('container-type-find');
                        }
                    }, function (error) {
                        errors.showError(error);
                    });
                };

                $scope.cancel = function () {
                    $state.go("container-type-find");
                };

            }]);
})();